<div class="main-container" *ngIf="sections[0] && currentlyVisibleSection === 0 && !isDataLoading"
	[class.disabled]="currentlyVisibleSection > 0 || isDataLoading" @fadeIn>

	<div class="main-form">
		<form [formGroup]="emailFormGroup"
			(keyup)="keyPressed($event)">
			<div class="login-type-wrapper">
				<div class="access-mode-label">Access Mode ({{ emailFormGroup.get('loginType').value == LoginType.Id ? 'ID/Password' : 'GeoFencing' }}):</div>
				<div class="access-mode-dropwdown-wrapper">
					<ng-container
						*ngIf="emailFormGroup.get('loginType').value == LoginType.Id; then user_login_template; else location_login_template"></ng-container>
					<ng-template #user_login_template>
						<mat-select formControlName="loginType">
							<mat-select-trigger>
								<mat-icon class="selected-item-svg-icon" svgIcon="lock"></mat-icon>
							</mat-select-trigger>
							<mat-option [value]="LoginType.Id">
								<mat-icon svgIcon="lock"></mat-icon>ID/Password
							</mat-option>
							<mat-option [value]="LoginType.Location">
								<mat-icon svgIcon="earth"></mat-icon>GeoFencing
							</mat-option>
						</mat-select>
					</ng-template>
					<ng-template #location_login_template>
						<mat-select formControlName="loginType">
							<mat-select-trigger>
								<mat-icon class="selected-item-svg-icon" svgIcon="earth"></mat-icon>
							</mat-select-trigger>
							<mat-option [value]="LoginType.Location">
								<mat-icon svgIcon="earth"></mat-icon>GeoFencing
							</mat-option>
							<mat-option [value]="LoginType.Id">
								<mat-icon svgIcon="lock"></mat-icon>ID/Password
							</mat-option>
						</mat-select>
					</ng-template>
				</div>
			</div>
			<mat-form-field>
				<mat-label>Email</mat-label>
				<input matInput formControlName="email" [disabled]="currentlyVisibleSection > 0 || isDataLoading" autocomplete="on" name="email"/>
			</mat-form-field>

			<p *ngIf="userPlatformTypes && !userPlatformTypes.length" class="email-not-found">We could not find your
				email!</p>

			<div class="form-button-container">
				<button mat-raised-button type="button" (click)="checkEmail()"
					[disabled]="emailFormGroup.invalid || currentlyVisibleSection > 0 || isDataLoading">Proceed</button>
			</div>
		</form>
	</div>
</div>

<div class="main-container user-type-container" *ngIf="sections[1] && currentlyVisibleSection === 1 && !isDataLoading"
	[class.disabled]="currentlyVisibleSection > 1 || isDataLoading" @fadeIn>

	<h3>What do you want to do?</h3>

	<div class="actions-container">
		<button mat-raised-button (click)="selectUserType(UserPlatformType.Customer); "
			*ngIf="userTypeFormGroup.get('hasCustomer').value"
			[disabled]="currentlyVisibleSection > 1 || isDataLoading">
			Management and Reporting
		</button>

		<button mat-raised-button (click)="selectUserType(UserPlatformType.Vendor);"
			*ngIf="userTypeFormGroup.get('hasVendor').value" [disabled]="currentlyVisibleSection > 1 || isDataLoading">
			Inspections and Measurements
		</button>
	</div>
</div>

<!-- <div class="main-container" *ngIf="sections[2] && currentlyVisibleSection === 2 && !isDataLoading"
	[class.disabled]="currentlyVisibleSection > 2 || isDataLoading" @fadeIn>

	<h3>Presentation</h3>

	<div class="actions-container">
		<button mat-raised-button (click)="selectDevice(LoginDevice.Desktop)"
			[disabled]="currentlyVisibleSection > 2 || isDataLoading">
			Portal View
		</button>

		<button mat-raised-button (click)="selectDevice(LoginDevice.Mobile)"
			[disabled]="currentlyVisibleSection > 2 || isDataLoading">
			Mobile Friendly
		</button>
	</div>
</div> -->

<app-loader [isInline]="true" *ngIf="isDataLoading"></app-loader>